var isProduction = true;
var url = "";
let recaptcha = "";
let GClientID = "";
let API_KEY = "";
if (isProduction) {
  url = process.env.REACT_APP_FIREBASE_URL;
  recaptcha = process.env.REACT_APP_RECAPTCHA_SITE_KEY_PRD;
  GClientID = process.env.REACT_APP_GOOGLE_CLIENT_ID_PRD;
  API_KEY = process.env.REACT_APP_API_KEY;
} else {
  url = process.env.REACT_APP_FIREBASE_URL_DEV;
  recaptcha = process.env.REACT_APP_RECAPTCHA_SITE_KEY_DEV;
  GClientID = process.env.REACT_APP_GOOGLE_CLIENT_ID_Dev;
  API_KEY = process.env.REACT_APP_API_KEY;
}
//vg
const config = {
  WS_BASE_URL: `${process.env.REACT_APP_BASE_URL}`,
  FIREBASE_WS_BASE_URL: `${url}`,
  STRIPE_PK_DEV: `${process.env.STRIPE_PK_DEV}`,
  STRIPE_PK_PRODUCTION: `${process.env.STRIPE_PK_PRODUCTION}`,
  DOMAIN_NAME: `${process.env.REACT_APP_LOCAL_HOST}`,
  DEMO: false,
  FIREBASE_BASIC_AUTH_TOKEN: `${process.env.REACT_APP_API_KEY}`,
  RECAPTCHA_SITE_KEY: `${recaptcha}`,
  GOOGLE_CLIENT_ID: `${GClientID}`,
  APIKEY: `${API_KEY}`,
};

export default config;
